import { setUser } from "@sentry/react";
import TransitionalRegion from "components/TransitionalRegion";
import SPINNER_MODE from "enums/SPINNER_MODE";
import { SWR_OPTION } from "hooks/api/useApiGet";
import useGetSession from "hooks/api/useGetSession";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import { keyApp, usePersistStore, useStore } from "hooks/useStore";
import { useLayoutEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAppStore from "./hooks/useAppStore";

const isLogin = () => {
  const currentToken = usePersistStore.getState().token;
  return (
    Boolean(currentToken) &&
    typeof currentToken === "string" &&
    currentToken.trim().length > 0
  );
};

const AuthContainerLogic = () => {
  const { navigate } = useVidletNavigate();
  const location = useLocation();
  const currentToken = usePersistStore((s) => s.token);
  const id = useStore((s) => s[keyApp].currentUser.id) || null;
  const handleAppChange = useStore((s) => s[keyApp].handleAppChange);
  const { currentUser } = useAppStore();
  const { session, error } = useGetSession({
    swrOptions: SWR_OPTION.CALL_ONCE,
  });

  useLayoutEffect(() => {
    if (session) {
      handleAppChange("currentUser", session);
    }
  }, [session, error, handleAppChange]);

  //  Recheck the token in localStorage on every path, before render anything
  useLayoutEffect(() => {
    const {
      state: { token = null },
    } = JSON.parse(localStorage.getItem("VIDLET") || "") || {
      state: { token: null },
    };

    if (currentToken !== token) {
      navigate("login", { state: window.location.pathname });
    }
  }, [currentToken, location, navigate]);

  // loading wait for validate token
  if (id === null)
    return (
      <TransitionalRegion showSpinner spinnerMode={SPINNER_MODE.BUTTERFLY} />
    );

  // If no token = mean no login
  if (!isLogin()) {
    return <Navigate to="login" state={window.location.pathname} />;
  }

  setUser({
    id: currentUser?.id,
    email: currentUser?.email,
    username: currentUser?.firstName + " " + currentUser?.lastName,
  });

  return <Outlet />;
};

export default AuthContainerLogic;
